// extracted by mini-css-extract-plugin
module.exports = {"payPalContainer":"PayPalCheckout_payPalContainer___BIrG","disabledOverlay":"PayPalCheckout_disabledOverlay__ngtUx","readOnly":"PayPalCheckout_readOnly__ttKQD"};